import { render, staticRenderFns } from "./Cellars.vue?vue&type=template&id=58cca366&scoped=true&"
import script from "./Cellars.vue?vue&type=script&lang=js&"
export * from "./Cellars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cca366",
  null
  
)

export default component.exports